const PATHS = {
  PLUGIN: 'plugin',
  DEMO_UI: 'demo-ui',
  // Plugin names
  START_PAGE: 'start-page'
} as const

export default PATHS
